import { Box, Button, Flex, Heading, Icon } from '@chakra-ui/react';
import { FaExclamationCircle } from 'react-icons/fa';
import { IoHomeOutline } from 'react-icons/io5';
import { AddressModel, UserModel } from 'models';
import UserProfileCard from './UserProfileCard';
import AddressDropdown from '../../AddressDropdown/AddressDropdown';

interface UserProfileAddressCardProps {
    user: UserModel;
    onAddAddress?: () => void;
    onManageAddress?: () => void;
    onRemoveAddress?: (address: AddressModel) => void;
}

export default function UserProfileAddressCard({
    user,
    onAddAddress,
    onManageAddress,
    onRemoveAddress
}: UserProfileAddressCardProps) {
    let content;
    const primary = user.getPrimaryAddress();
    const secondary = user.getSecondaryAddresses();
    const addresses: AddressModel[] = [];
    if (primary) addresses.push(primary);
    addresses.push(...secondary);

    const bottomButtonText = 'Add Address';

    const bottomButton = (
        <Button variant="outline" size="sm" onClick={!primary? onManageAddress : onAddAddress}>
            {bottomButtonText}
        </Button>
    );

    if (addresses.length) {
        content = (
            <AddressDropdown
                addresses={addresses}
                defaultAddress={addresses[0]}
                onAddAddress={onAddAddress}
                onEditAddress={onManageAddress}
                onRemoveAddress={onRemoveAddress}
                mode={'edit'}
            />
        );
    } else {
        content = (
            <Flex align="center" color="red.500">
                <Icon as={FaExclamationCircle} w={5} h={5} mr={2} />
                <Heading fontSize="sm">Please Add A Primary Address.</Heading>
            </Flex>
        );
    }

    return (
        <UserProfileCard
            title="Addresses"
            subtitle="Manage Your Addresses"
            icon={IoHomeOutline}
            bottomButton={bottomButton}
            children={content}
        />
    );
}
